import {useEffect} from 'react'
import {useNavigate} from '@github-ui/use-navigate'
import {useLocation} from '@github-ui/react-router'
import {pullsDashboardSurfaceContentRoute} from './pulls-dashboard-surface-content-route'

export function PullsDashboardSurfaceLegacyRedirects() {
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    if (location.pathname === '/pulls/mentioned') {
      navigate(pullsDashboardSurfaceContentRoute.generatePath({mode: 'involves'}), {replace: true})
      return
    }

    if (location.pathname === '/pulls/review-requested') {
      navigate(pullsDashboardSurfaceContentRoute.generatePath({mode: 'reviews'}), {replace: true})
    }
  }, [location.pathname, navigate])

  return null
}
